<template>
  <div>
    <Card class="bids-empty">
      <div class="bids-empty__content">
        <img src="~@/assets/images/keyword-planner.svg" />
        <h2 class="bids-empty__title">
          {{ $t('ADVERTISEMENT.KEYWORDS.EMPTY_TITLE') }}
        </h2>
        <p class="bids-empty__description">
          {{ $t('ADVERTISEMENT.KEYWORDS.EMPTY_DESCRIPTION') }}
        </p>

        <div class="bids-empty__actions">
          <ElButton type="primary" @click="openAddBidModal">
            {{ $t('ADVERTISEMENT.ADD_SINGLE_BID') }}
          </ElButton>
          <ElButton type="text" @click="goToAddCSV">
            {{ $t('ADVERTISEMENT.ADD_BULK_BID') }}
          </ElButton>
        </div>
      </div>
    </Card>

    <AddBidModal v-model="showAddBidModal" />
  </div>
</template>

<script>
import Card from '@@/common/Card';

import AddBidModal from './common/AddBidModal';

export default {
  name: 'BidsEmpty',
  components: {
    Card,
    AddBidModal,
  },
  data() {
    return {
      showAddBidModal: false,
    };
  },
  methods: {
    openAddBidModal() {
      this.showAddBidModal = true;
    },
    goToAddCSV() {
      this.$router.push({ name: 'search-ads-add-bulk-bids' });
    },
  },
};
</script>

<style lang="scss">
.bids-empty {
  &__content {
    padding: $global-padding * 5 $global-padding * 3;

    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__title {
    margin-top: $global-margin;
  }

  &__description {
    text-align: center;
    font-size: rem-calc(14px);
    font-weight: 400;
    color: #909399;
    margin: 0 0 $global-margin * 3;
  }

  &__actions {
    display: flex;
    justify-content: center;
  }
}
</style>
